import { gql } from "@apollo/client";

export const UPDATE_SURVEY_SUBMITTED = gql`
    mutation updateSurveySubmitData($groupId: String!) {
        updateSurveySubmitData(groupId: $groupId)
        {
            response
            success
            failureCode
            failureDescription
        }
    }
`

export const UPDATE_SURVEY_REOPEN = gql`
    mutation updateSurveyReopenData($groupId: String!) {
        updateSurveyReopenData(groupId: $groupId)
        {
            response
            success
            failureCode
            failureDescription
        }
    }
`
